import { ToastReduxAction } from '@ordermentum/ui-definitions';

export const showToast = (toast: ToastReduxAction) => async dispatch =>
  dispatch({
    type: toast.type,
    notificationTitle: toast.notificationTitle,
    notificationPayload: toast.notificationPayload,
    notificationDelay: toast.notificationDelay,
    notificationType: toast.notificationType,
  });
